import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgEyeOpenIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.6 18.404c-3.125-.655-5.827-3.054-7.382-5.38 1.151-1.776 2.823-3.472 4.78-4.54a5.093 5.093 0 1 0 8.088-.108c1.602.873 3.24 2.356 4.846 4.65-1.743 2.45-3.518 3.944-5.228 4.755-1.769.838-3.497.96-5.105.623Zm11.354-5.658C18.261 7.31 14.193 5.805 10.54 6.5c-3.588.683-6.613 3.463-8.34 6.265l-.165.266.167.264c1.615 2.55 4.603 5.335 8.193 6.088 1.808.379 3.76.24 5.739-.698 1.972-.935 3.942-2.65 5.82-5.374l.194-.281-.193-.284Zm-5.779-1.221a4.093 4.093 0 1 1-8.185 0 4.093 4.093 0 0 1 8.185 0Z"
      fill="#4D4D4D"
    />
  </svg>
);
const Memo = memo(SvgEyeOpenIcon);
export default Memo;
